import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.function.bind";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.object.assign";

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

import staticQueryData from "../../public/static/d/610389658.json";
import React from 'react';
import { StaticQuery } from 'gatsby';
import Header from '../components/Header';
import Footer from '../components/Footer';
import LNB from '../components/LNB';
import Resizable from '../components/Resizable';
var LNB_WIDTH = 260;
var LNB_MIN_WIDTH = 212;
export var Layout =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Layout, _React$Component);

  function Layout() {
    var _this;

    _this = _React$Component.call(this) || this;
    _this.state = {
      width: LNB_WIDTH
    };
    _this.handleMouseMove = _this.changeWidth.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = Layout.prototype;

  _proto.changeWidth = function changeWidth(ev) {
    ev.preventDefault(); // to prevent user-select's work

    this.setState({
      width: Math.max(ev.pageX, LNB_MIN_WIDTH)
    });
  };

  _proto.render = function render() {
    var _this$props = this.props,
        data = _this$props.data,
        tabIndex = _this$props.tabIndex,
        selectedNavItemId = _this$props.selectedNavItemId,
        children = _this$props.children;
    var header = data.header,
        footer = data.footer,
        useExample = data.useExample;
    var lnbWidth = this.state.width;
    return React.createElement("div", {
      className: "wrapper"
    }, React.createElement(Header, {
      data: header
    }), React.createElement("main", {
      className: "body",
      style: {
        paddingLeft: lnbWidth
      }
    }, React.createElement(LNB, {
      useExample: useExample,
      tabIndex: tabIndex,
      selectedNavItemId: selectedNavItemId,
      width: lnbWidth
    }), React.createElement("section", {
      className: "content"
    }, children), React.createElement(Resizable, {
      left: lnbWidth,
      handleMouseMove: this.handleMouseMove
    })), React.createElement(Footer, {
      infoList: footer
    }));
  };

  return Layout;
}(React.Component);

var LayoutWrapper = function LayoutWrapper(props) {
  return React.createElement(StaticQuery, {
    query: "610389658",
    render: function render(data) {
      return React.createElement(Layout, Object.assign({
        data: data.allLayoutJson.edges[0].node
      }, props));
    },
    data: staticQueryData
  });
};

export default LayoutWrapper;